var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCaretDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 4.89
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4.89a.89.89 0 01-.62-.26L.26 1.5a.86.86 0 010-1.24.86.86 0 011.24 0L4 2.77 6.5.28a.88.88 0 011.24 0 .86.86 0 010 1.24L4.63 4.63a.87.87 0 01-.63.26z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjQuODkiIHZpZXdCb3g9IjAgMCA4IDQuODkiPgogIDxwYXRoIGQ9Ik00LDQuODlhLjg5Ljg5LDAsMCwxLS42Mi0uMjZMLjI2LDEuNUEuODYuODYsMCwwLDEsLjI2LjI2Ljg2Ljg2LDAsMCwxLDEuNS4yNkw0LDIuNzcsNi41LjI4YS44OC44OCwwLDAsMSwxLjI0LDAsLjg2Ljg2LDAsMCwxLDAsMS4yNEw0LjYzLDQuNjNBLjg3Ljg3LDAsMCwxLDQsNC44OVoiLz4KPC9zdmc+Cg==";
export { SvgCaretDown as ReactComponent };